import { render, staticRenderFns } from "./element.vue?vue&type=template&id=bdfaf196"
import script from "./element.vue?vue&type=script&lang=js"
export * from "./element.vue?vue&type=script&lang=js"
import style0 from "./element.vue?vue&type=style&index=0&id=bdfaf196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports